export const firebaseConfig = {
    apiKey: 'AIzaSyCW24CW1fC0qnfXqRFRPFoZ-UydWfsrj28',
    authDomain: 'primable-44025.firebaseapp.com',
    projectId: 'primable-44025',
    storageBucket: 'primable-44025.appspot.com',
    messagingSenderId: '684233572673',
    appId: '1:684233572673:web:c9995fae28e059968a21c0',
    measurementId: 'G-V1RQJ2PLV9',
};
